import { call, put, takeLatest } from "redux-saga/effects";
import { push } from "react-router-redux";
import swal from "sweetalert";

import {
  Creators as PointsActions,
  Types as PointsTypes,
} from "store/ducks/points";
import points from "services/points";

function* getPointRequest(action) {
  try {
    const { id } = action.payload;
    const url = `/experience/bulk_points_assigner/${id}`;
    const response = yield call(points.get, url);

    yield put(PointsActions.getPointSuccess(response.data));
  } catch (error) {
    yield put(PointsActions.getPointFailure());
  }
}

function* getPointsRequest(action) {
  try {
    const { page } = action.payload;
    const url = `/experience/bulk_points_assigner?page=${page}&per=25`;
    const response = yield call(points.get, url);

    yield put(PointsActions.getPointsSuccess(response.data));
  } catch (error) {
    yield put(PointsActions.getPointsFailure());
  }
}

function* createPointRequest(action) {
  try {
    const { data } = action.payload;
    const url = `experience/bulk_points_assigner`;
    yield call(points.post, url, data);

    yield put(push("/points/cpf-list"));
    yield call(
      swal,
      "Adicionado",
      "Pontos adicionados com sucesso!",
      "success"
    );
    yield put(PointsActions.createPointSuccess());
  } catch (error) {
    yield call(
      swal,
      "Falha ao atualizar",
      "Não foi possível criar adicionar os pontos.",
      "error"
    );
    yield put(PointsActions.createPointFailure());
  }
}

export default function* saga() {
  yield takeLatest(PointsTypes.GET_REQUEST, getPointRequest);
  yield takeLatest(PointsTypes.GET_LIST_REQUEST, getPointsRequest);
  yield takeLatest(PointsTypes.CREATE_REQUEST, createPointRequest);
}
